import { useQuery } from '@tanstack/react-query';

import { CashFlowsApi } from '../../apis';
import { QueryKeys } from '../query-keys';

const useCashflows = (
  page = 1,
  perPage = 100,
  filter?: { startMonth: string | null; endMonth: string | null }
) => {
  const query = useQuery({
    queryKey: [QueryKeys.CASHFLOWS, page, perPage, filter],
    queryFn: () => CashFlowsApi.getPage({ page, perPage, filter }),
  });

  return {
    isLoading: query.isPending,
    hasError: query.isError,
    cashflows: query.data?.cashflows || [],
    page: query.data?.page || 1,
    total: query.data?.total || 0,
    totalPages: query.data?.totalPages || 0,
  };
};

export default useCashflows;
